module.exports = __webpack_public_path__ + "static/favicon.396b890d.ico";


//////////////////
// WEBPACK FOOTER
// ./src/images/favicon.ico
// module id = 455
// module chunks = 34471704633725 114276838955818 216468464745311